import { BaseScreen } from "./BaseScreen";

import { AccountHeader } from "./components/AccountHeader";

import { ConfirmCancelSubscriptionBlock } from "../blocks/ConfirmCancelSubscriptionBlock";

import type { HeaderEvents } from "./components/HeaderEvents";
import type { StateStore } from "../app/state/StateStore";
import type { Block } from "../blocks/Block";
import type { AccountActions } from "./components/AccountActions";

export class ConfirmCancelSubscriptionScreen
    extends BaseScreen {

    private readonly store: StateStore;

    private readonly headerEvents: HeaderEvents;

    private readonly actions: AccountActions;

    private readonly blocks: Block[] = [];

    constructor(
        store: StateStore,
        headerEvents: HeaderEvents,
        actions: AccountActions
    ) {

        super();

        this.store = store;
        this.headerEvents = headerEvents;
        this.actions = actions;

    }

    public override mount(): void {

        super.mount();

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        super.update();

        for (const block of this.blocks) {
            block.unmount();
        }

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public override unmount(): void {

        for (const block of this.blocks) {
            block.unmount();
        }

        this.blocks.length = 0;

        super.unmount();

    }

    // =========================================================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        root.className =
            "account-screen";

        const header =
            new AccountHeader(

                this.headerEvents,

                this.store.getState()
                    .accountData?.email ?? ""

            );

        header.mount();

        root.appendChild(
            header.getRoot()
        );

        const content =
            document.createElement("div");

        content.className =
            "content";

        content.style.paddingTop =
            "48px";

        this.buildBlocks();

        for (const block of this.blocks) {

            block.mount();

            content.appendChild(
                block.getRoot()
            );

        }

        root.appendChild(
            content
        );

        return root;

    }

    private buildBlocks(): void {

        this.blocks.length = 0;

        const selected =
            this.store.getState()
                .selectedSubscription;

        if (!selected) {
            return;
        }

        this.blocks.push(

            new ConfirmCancelSubscriptionBlock(

                selected,

                this.actions

            )

        );

    }

}